import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { GoogleReCaptchaProvider } from '@google-recaptcha/react';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

import store from '@/redux/store';

import App from './App.jsx';

import '@/css/reset.css';
import '@/css/fonts.css';
import '@/css/variables.css';
import '@/css/index.css';
import '@/css/buttons.css';
import '@/css/snippets.css';
import 'slick-carousel/slick/slick.css';
import '@/css/slick-carousel.css';
import '@/css/fa_6_7_2.css';
// import '@/css/notiflix.css';

Notify.init({
  borderRadius: '12px',
  fontFamily: 'Manrope',
  fontSize: '12px',
  timeout: 3000,
  useFontAwesome: true,
  success: {
    background: '#22232b',
    textColor: '#787e95',
    fontAwesomeClassName: 'fas fa-check-circle',
    fontAwesomeIconColor: '#fdfdfd',
  },
  failure: {
    background: '#22232b',
    textColor: '#787e95',
    fontAwesomeClassName: 'fa fa-times-circle',
    fontAwesomeIconColor: '#f2d280',
  },
  warning: {
    background: '#22232b',
    textColor: '#787e95',
    fontAwesomeClassName: 'fa fa-info-circle',
    fontAwesomeIconColor: '#e5a500',
  },
});

const GOOGLE_RECAPTCHA_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY;

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <GoogleReCaptchaProvider
      type="v3"
      siteKey={GOOGLE_RECAPTCHA_KEY}
      scriptProps={{ async: true }}
    >
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </GoogleReCaptchaProvider>
  </StrictMode>,
);
